import { render, staticRenderFns } from "./FotoConfig.vue?vue&type=template&id=0019d962&scoped=true"
import script from "./FotoConfig.vue?vue&type=script&lang=js"
export * from "./FotoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019d962",
  null
  
)

export default component.exports